module.exports = __webpack_public_path__ + "823883e68048910613dee4e42750eb08.png";